import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Buffer } from 'buffer';
import React, { Component } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { isApiGatewayUrl } from '../utils/is-api-gateway-url';
import truncate from '../utils/Truncate';
import FeedbackForm from './FeedbackForm';
var MAX_SUMMARY_LENGTH_CHARS = 100;
var singleLineTruncatedText = function singleLineTruncatedText(text) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_SUMMARY_LENGTH_CHARS;
  var singleLineText = text.replace(/\n/g, ' ');
  return truncate(singleLineText, length);
};
var FeedbackCollector = /*#__PURE__*/function (_Component) {
  function FeedbackCollector() {
    var _this;
    _classCallCheck(this, FeedbackCollector);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FeedbackCollector, [].concat(args));
    _defineProperty(_this, "state", {
      anonymousFeedback: true
    });
    _defineProperty(_this, "postFeedback", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formValues) {
        var entrypointId, fetchUrl, formData, body, postData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              entrypointId = _this.props.entrypointId;
              fetchUrl = _this.getFeedbackUrl(); // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
              if (!entrypointId) {
                _context.next = 10;
                break;
              }
              _context.next = 5;
              return _this.mapFormToJSD(formValues);
            case 5:
              formData = _context.sent;
              body = {
                feedback: _objectSpread({
                  entrypointId: _this.props.entrypointId,
                  entrypointUiVersion: _this.getPackageVersion()
                }, formData)
              };
              if (isApiGatewayUrl(fetchUrl)) {
                fetchUrl += '/feedback-collector-api';
              } else if (!_this.props.customFeedbackUrl) {
                fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
              }
              postData = Buffer.from(JSON.stringify(body)).toString('base64');
              fetch("".concat(fetchUrl, "/v2/feedback"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  data: postData
                }),
                credentials: 'include'
              });
            case 10:
              _this.props.onClose();

              // slightly delay confirming submit since we don't wait for the REST call to succeed
              //
              // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
              // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
              // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
              //
              setTimeout(function () {
                return _this.props.onSubmit(formValues);
              }, _this.props.timeoutOnSubmit);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }
  _inherits(FeedbackCollector, _Component);
  return _createClass(FeedbackCollector, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var anonymousFeedback;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.shouldShowOptInCheckboxesNew();
            case 2:
              anonymousFeedback = !_context2.sent;
              this.setState({
                anonymousFeedback: anonymousFeedback
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "getGatewayUrl",
    value: function getGatewayUrl() {
      var _this$props = this.props,
        customGatewayUrl = _this$props.customGatewayUrl,
        url = _this$props.url;
      if (customGatewayUrl) {
        return customGatewayUrl;
      }
      if (url) {
        return url;
      }
      return FeedbackCollector.defaultProps.url;
    }
  }, {
    key: "getFeedbackUrl",
    value: function getFeedbackUrl() {
      var _this$props2 = this.props,
        customFeedbackUrl = _this$props2.customFeedbackUrl,
        url = _this$props2.url;
      if (customFeedbackUrl) {
        return customFeedbackUrl;
      }
      if (url) {
        return url;
      }
      return FeedbackCollector.defaultProps.url;
    }
  }, {
    key: "getPackageVersion",
    value: function getPackageVersion() {
      return "0.0.0-development" || 'Unknown, at least 11.0.0';
    }
  }, {
    key: "getEntitlementInformation",
    value: function () {
      var _getEntitlementInformation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _entitlementDetails, _entitlementDetails2, _productName, _entitlement;
        var url, productName, productEntitlement, entitlementDetails, productKey, _document$querySelect, hasPremium, entitlement, entitlementInformation, cloudSiteId, _entitlementDetails3;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = this.getGatewayUrl(); // jira / confluence / bitbucket / trello
              if (!window.location.host.includes('bitbucket.org')) {
                _context3.next = 9;
                break;
              }
              productName = 'Bitbucket';
              productKey = 'bitbucket';
              entitlementDetails = JSON.parse(JSON.stringify((_document$querySelect = document.querySelector('meta[id="bb-bootstrap"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.getAttribute('data-current-user')));
              hasPremium = entitlementDetails['hasPremium'];
              productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
              _context3.next = 24;
              break;
            case 9:
              if (!['trellis.coffee', 'trello.com'].includes(window.location.host)) {
                _context3.next = 14;
                break;
              }
              productName = 'Trello';
              productKey = 'trello';
              _context3.next = 24;
              break;
            case 14:
              if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
              } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
              }
              _context3.prev = 15;
              _context3.next = 18;
              return fetch("".concat(url, "/customer-context/entitlements/").concat(window.location.host), _objectSpread({
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }, isApiGatewayUrl(url) ? {
                credentials: 'include'
              } : {}));
            case 18:
              entitlementDetails = _context3.sent;
              _context3.next = 24;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](15);
              entitlementDetails = undefined;
            case 24:
              entitlementInformation = [];
              cloudSiteId = ((_entitlementDetails = entitlementDetails) === null || _entitlementDetails === void 0 ? void 0 : _entitlementDetails.cloudSiteId) || '';
              if ((_entitlementDetails2 = entitlementDetails) !== null && _entitlementDetails2 !== void 0 && _entitlementDetails2.children) {
                entitlement = (_entitlementDetails3 = entitlementDetails) === null || _entitlementDetails3 === void 0 ? void 0 : _entitlementDetails3.children.find(function (entitlement) {
                  return entitlement.key === productKey;
                });
              }
              entitlementInformation.push({
                id: 'product',
                value: productName ? (_productName = productName) === null || _productName === void 0 ? void 0 : _productName.toLowerCase() : ''
              }, {
                id: 'hostingType',
                value: (_entitlement = entitlement) !== null && _entitlement !== void 0 && _entitlement.product ? entitlement.product.hostingType : 'CLOUD'
              }, {
                id: 'entitlementEdition',
                value: productEntitlement !== null && productEntitlement !== void 0 ? productEntitlement : ''
              }, {
                id: 'cloudId',
                value: cloudSiteId
              });
              return _context3.abrupt("return", entitlementInformation);
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[15, 21]]);
      }));
      function getEntitlementInformation() {
        return _getEntitlementInformation.apply(this, arguments);
      }
      return getEntitlementInformation;
    }()
  }, {
    key: "getTypeFieldValue",
    value: function getTypeFieldValue(dtype) {
      switch (dtype) {
        case 'bug':
          return this.props.typeBugDefaultValue;
        case 'comment':
          return this.props.typeCommentDefaultValue;
        case 'suggestion':
          return this.props.typeSuggestionDefaultValue;
        case 'question':
          return this.props.typeQuestionDefaultValue;
        case 'empty':
        default:
          return this.props.typeEmptyDefaultValue;
      }
    }
  }, {
    key: "getAtlassianID",
    value: function () {
      var _getAtlassianID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$props3, atlassianAccountId, shouldGetEntitlementDetails, url, result, json;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this$props3 = this.props, atlassianAccountId = _this$props3.atlassianAccountId, shouldGetEntitlementDetails = _this$props3.shouldGetEntitlementDetails;
              _context4.prev = 1;
              if (!(atlassianAccountId || !shouldGetEntitlementDetails)) {
                _context4.next = 4;
                break;
              }
              return _context4.abrupt("return", atlassianAccountId);
            case 4:
              url = this.getGatewayUrl();
              _context4.next = 7;
              return fetch("".concat(url, "/me"), _objectSpread({
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }, isApiGatewayUrl(url) ? {
                credentials: 'include'
              } : {}));
            case 7:
              result = _context4.sent;
              _context4.next = 10;
              return result.json();
            case 10:
              json = _context4.sent;
              return _context4.abrupt("return", json.account_id);
            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4["catch"](1);
              return _context4.abrupt("return", undefined);
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 14]]);
      }));
      function getAtlassianID() {
        return _getAtlassianID.apply(this, arguments);
      }
      return getAtlassianID;
    }()
  }, {
    key: "shouldShowOptInCheckboxes",
    value: function shouldShowOptInCheckboxes() {
      if (this.props.anonymousFeedback) {
        return !this.props.anonymousFeedback;
      }
      if (this.props.atlassianAccountId) {
        return true;
      }
      var response;
      this.getAtlassianID().then(function (result) {
        response = result !== undefined;
      }).catch(function () {
        response = false;
      });
      // @ts-ignore
      return response;
    }
  }, {
    key: "shouldShowOptInCheckboxesNew",
    value: function shouldShowOptInCheckboxesNew() {
      var _this2 = this;
      return new Promise(function (resolve) {
        if (_this2.props.anonymousFeedback) {
          resolve(!_this2.props.anonymousFeedback);
        }
        if (_this2.props.atlassianAccountId) {
          resolve(true);
        }
        _this2.getAtlassianID().then(function (result) {
          resolve(result !== undefined);
        }).catch(function () {
          resolve(false);
        });
      });
    }
  }, {
    key: "getDescription",
    value: function getDescription(formValues) {
      return formValues.description || this.props.descriptionDefaultValue;
    }
  }, {
    key: "getSummary",
    value: function getSummary(formValues) {
      return singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
  }, {
    key: "getCustomerName",
    value: function getCustomerName() {
      var _this$props$name;
      return (_this$props$name = this.props.name) !== null && _this$props$name !== void 0 ? _this$props$name : this.props.customerNameDefaultValue;
    }
  }, {
    key: "addEmailToContext",
    value: function addEmailToContext() {
      var contextField = this.props.additionalFields.find(function (field) {
        return field.id === 'customfield_10047';
      });
      if (contextField) {
        contextField.value = "".concat(contextField.value, "\n        email: ").concat(this.props.email);
      } else {
        this.props.additionalFields.push({
          id: 'customfield_10047',
          value: "email: ".concat(this.props.email)
        });
      }
    }
  }, {
    key: "addAccountIdToContext",
    value: function addAccountIdToContext(atlassianID) {
      if (atlassianID) {
        var contextField = this.props.additionalFields.find(function (field) {
          return field.id === 'customfield_10047';
        });
        if (contextField) {
          contextField.value = "".concat(contextField.value, "\n\t\t\tatlassian-account-id: ").concat(atlassianID);
        }
      }
    }
  }, {
    key: "mapFormToJSD",
    value: function () {
      var _mapFormToJSD = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(formValues) {
        var _this$props4, _this$props5;
        var entitlementInformation, atlassianID;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              entitlementInformation = null;
              if (!((_this$props4 = this.props) !== null && _this$props4 !== void 0 && _this$props4.shouldGetEntitlementDetails)) {
                _context5.next = 5;
                break;
              }
              _context5.next = 4;
              return this.getEntitlementInformation();
            case 4:
              entitlementInformation = _context5.sent;
            case 5:
              if ((_this$props5 = this.props) !== null && _this$props5 !== void 0 && _this$props5.email) {
                this.addEmailToContext();
              }
              _context5.next = 8;
              return this.getAtlassianID();
            case 8:
              atlassianID = _context5.sent;
              this.addAccountIdToContext(atlassianID);
              return _context5.abrupt("return", {
                fields: [].concat(_toConsumableArray(entitlementInformation !== null && entitlementInformation || []), [this.props.showTypeField ? {
                  id: this.props.typeFieldId,
                  value: this.getTypeFieldValue(formValues.type)
                } : undefined, {
                  id: this.props.summaryFieldId,
                  value: this.getSummary(formValues)
                }, {
                  id: this.props.descriptionFieldId,
                  value: this.getDescription(formValues)
                }, {
                  id: 'aaidOrHash',
                  value: formValues.canBeContacted ? atlassianID : undefined
                }, {
                  id: this.props.customerNameFieldId,
                  value: this.getCustomerName()
                }, formValues.canBeContacted ? {
                  id: this.props.canBeContactedFieldId,
                  value: this.props.canBeContactedAgreeValue
                } : {
                  id: this.props.canBeContactedFieldId,
                  value: this.props.canBeContactedDeclineValue
                }, formValues.enrollInResearchGroup ? {
                  id: this.props.enrollInResearchFieldId,
                  value: this.props.enrollInResearchAgreeValue
                } : {
                  id: this.props.enrollInResearchFieldId,
                  value: this.props.enrollInResearchDeclineValue
                }], _toConsumableArray(this.props.additionalFields)).filter(Boolean)
              });
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function mapFormToJSD(_x2) {
        return _mapFormToJSD.apply(this, arguments);
      }
      return mapFormToJSD;
    }()
  }, {
    key: "render",
    value: function render() {
      var anonymousFeedback = !this.shouldShowOptInCheckboxes();
      return /*#__PURE__*/React.createElement(FeedbackForm, _extends({
        customContent: this.props.customContent,
        feedbackTitle: this.props.feedbackTitle,
        feedbackTitleDetails: this.props.feedbackTitleDetails,
        showTypeField: this.props.showTypeField,
        showDefaultTextFields: this.props.showDefaultTextFields,
        hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
        canBeContactedLabel: this.props.canBeContactedLabel,
        enrolInResearchLabel: this.props.enrolInResearchLabel,
        summaryPlaceholder: this.props.summaryPlaceholder,
        submitButtonLabel: this.props.submitButtonLabel,
        cancelButtonLabel: this.props.cancelButtonLabel,
        feedbackGroupLabels: this.props.feedbackGroupLabels,
        onSubmit: this.postFeedback,
        onClose: this.props.onClose,
        locale: this.props.locale,
        anonymousFeedback: fg('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
        selectLabel: this.props.selectLabel,
        customTextAreaLabel: this.props.customTextAreaLabel,
        customFeedbackOptions: this.props.customFeedbackOptions,
        shouldReturnFocusRef: this.props.shouldReturnFocusRef,
        disableSubmitButton: this.props.disableSubmitButton
      }, fg('jfp_a11y_team_feedback_collector_nested_elements') && {
        enrolInResearchLink: this.props.enrolInResearchLink,
        canBeContactedLink: this.props.canBeContactedLink
      }));
    }
  }]);
}(Component);
_defineProperty(FeedbackCollector, "defaultProps", {
  locale: 'en',
  url: '/gateway/api',
  shouldGetEntitlementDetails: true,
  canBeContactedFieldId: 'customfield_10043',
  canBeContactedAgreeValue: [{
    id: '10109'
  }],
  canBeContactedDeclineValue: [{
    id: '10111'
  }],
  additionalFields: [],
  customerNameFieldId: 'customfield_10045',
  customerNameDefaultValue: 'unknown',
  descriptionFieldId: 'description',
  descriptionDefaultValue: '',
  enrollInResearchFieldId: 'customfield_10044',
  enrollInResearchAgreeValue: [{
    id: '10110'
  }],
  enrollInResearchDeclineValue: [{
    id: '10112'
  }],
  summaryFieldId: 'summary',
  summaryDefaultValue: '',
  summaryTruncateLength: 100,
  timeoutOnSubmit: 700,
  typeFieldId: 'customfield_10042',
  typeBugDefaultValue: {
    id: '10105'
  },
  typeCommentDefaultValue: {
    id: '10106'
  },
  typeSuggestionDefaultValue: {
    id: '10107'
  },
  typeQuestionDefaultValue: {
    id: '10108'
  },
  typeEmptyDefaultValue: {
    id: 'empty'
  },
  showTypeField: true,
  showDefaultTextFields: true,
  anonymousFeedback: false,
  onClose: function onClose() {},
  onSubmit: function onSubmit() {}
});
export { FeedbackCollector as default };